var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftChevronGold = function SvgLeftChevronGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.985 14.167.904-.877L1.918 7.5l5.97-5.79-.903-.877L.11 7.5l6.874 6.667Z",
    fill: "#FFC83E"
  })));
};
export { SvgLeftChevronGold as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDggMTUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi45ODQ4OSAxNC4xNjY3TDcuODg4OTIgMTMuMjg5OUwxLjkxNzkgNy41MDAzM0w3Ljg4ODkyIDEuNzA5NDhMNi45ODQ5IDAuODMzMzU0TDAuMTExMTM4IDcuNTAwMzNMNi45ODQ4OSAxNC4xNjY3WiIgZmlsbD0iI0ZGQzgzRSIvPgo8L3N2Zz4K";